export const RECEIVE_LOAN_PLAN = "RECEIVE_LOAN_PLAN";
export const RECEIVE_LOAN_PLANS = "RECEIVE_LOAN_PLANS";
export const RECEIVE_REPAYMENTS = "RECEIVE_REPAYMENTS";
export const RECEIVE_UPCOMING_PAYMENTS = "RECEIVE_UPCOMING_PAYMENTS";
export const CREATE_DRAW_DOWN = "CREATE_DRAW_DOWN";



// WEBPACK FOOTER //
// ./src/features/loans/loanPlanActionTypes.js